import React from 'react';
import { Link } from 'react-router-dom';
import { StepState } from './StepState';
import {
  Horizontal,
  HorizontalBar,
  StepWrapper,
  StyledClamp,
  StyledProblemSmallIcon,
  StyledStepContainer,
  StyledStepNumber,
  StyledStepText,
  StyledTickSmallIcon,
} from './styled';

export interface StepProps {
  state: StepState;
  isFailedStep?: boolean;
  text?: string;
  url?: string;
  stepNumber?: number;
  firstStep?: boolean;
  lastStep?: boolean;
  afterCurrent?: boolean;
}

const numberStepIcon = (state: StepState, stepNumber: number | undefined) => (
  <StyledStepContainer state={state}>
    <StyledStepNumber>{stepNumber}</StyledStepNumber>
  </StyledStepContainer>
);

const displayStepIcon = (
  state: StepState,
  stepNumber: number | undefined,
  isFailedStep?: boolean,
) => {
  if (isFailedStep) {
    return (
      <StyledStepContainer isFailedStep={isFailedStep}>
        <div>
          <StyledProblemSmallIcon />
        </div>
      </StyledStepContainer>
    );
  }
  if (state === StepState.Previous) {
    return (
      <StyledStepContainer state={state}>
        <StyledTickSmallIcon />
      </StyledStepContainer>
    );
  }
  return numberStepIcon(state, stepNumber);
};

export const Step: React.FC<StepProps> = ({
  state,
  isFailedStep,
  text,
  url,
  stepNumber,
  firstStep,
  lastStep,
  afterCurrent,
}) => {
  const step = (
    <>
      <Horizontal>
        {displayStepIcon(state, stepNumber, isFailedStep)}
        {!lastStep && <HorizontalBar state={state} />}
      </Horizontal>
      {url && state !== StepState.Next ? (
        <Link to={url}>
          <StyledStepText
            state={state}
            isFailedStep={isFailedStep}
            lastStep={lastStep}>
            <StyledClamp>{text}</StyledClamp>
          </StyledStepText>
        </Link>
      ) : (
        <StyledStepText
          state={state}
          isFailedStep={isFailedStep}
          lastStep={lastStep}>
          <StyledClamp>{text} </StyledClamp>
        </StyledStepText>
      )}
    </>
  );

  return (
    <StepWrapper firstStep={firstStep} afterCurrent={afterCurrent}>
      {step}
    </StepWrapper>
  );
};
